import { ReactNode, useEffect, useRef } from "react";
import clsx from "clsx";
import "./chipper.scss";

interface ChipperProps {
  children: ReactNode;
  className?: string;
  backgroundColor?: string;
}

export const Chipper = ({
  children,
  className,
  backgroundColor,
}: ChipperProps) => {
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.style.backgroundColor =
        backgroundColor || "rgba(119, 119, 119, 1)";
    }
  }, [backgroundColor]);

  return (
    <span ref={ref} className={clsx("chipper-container", className)}>
      {children}
    </span>
  );
};
